import { IWidget } from "@/types/map";
// import {loadModules} from "esri-loader";
import MeasurementDiv from "@/plugin/gis-viewer/widgets/WidgetsManager/bd-gl/MeasurementBDGL.vue";
import searchPop from "@/plugin/gis-viewer/widgets/WidgetsManager/bd-gl/searchPopBDGL.vue";
import { Vue } from "vue-property-decorator";
// import {removeData, type} from "jquery";

declare let BMapGL: any;
// declare let BMapLib: any;

export default class WidgetsManagerBD {
  private view!: any;
  private static intances: Map<string, WidgetsManagerBD>;

  private constructor(view: any) {
    this.view = view;
  }
  public static getInstance(view: any) {
    let id = view.getContainer().id;
    if (!WidgetsManagerBD.intances) {
      WidgetsManagerBD.intances = new Map();
    }
    let instance = WidgetsManagerBD.intances.get(id);
    if (!instance) {
      instance = new WidgetsManagerBD(view);
      WidgetsManagerBD.intances.set(id, instance);
    }
    return instance;
  }
  public async initWidgets(params: Array<IWidget>) {
    let widgets: Array<IWidget> = params;
    widgets.forEach((widget) => {
      let relativePos: any;
      let position: string = "top-left";
      let toolDiv: any = undefined;
      let defaultVisible = widget.visible !== false;
      let vm: any;
      switch (widget.name) {
        case "zoom":
          let top_left_navigation = new BMapGL.NavigationControl(); //左上角，添加默认缩放平移控件
          this.view.addControl(top_left_navigation);
          toolDiv = document.getElementsByClassName("BMap_stdMpCtrl")[0];
          break;
        case "draw":
          break;
        case "measure":
          //测线工具
          vm = new Vue({
            // 为什么不使用 template 要使用render 因为现在是webpack里面没有编译器 只能使用render
            render: (h) => h(MeasurementDiv, { props: { map: this.view } } as any) // render 生成虚拟dom  {props: props}
          }).$mount(); // $mount 生成真实dom, 挂载dom 挂载在哪里, 不传参的时候只生成不挂载，需要手动挂载
          toolDiv = vm.$el as HTMLElement;
          toolDiv.id = "measure";
          break;
        case "locate":
          //定位工具
          // Add the locate widget to the top left corner of the view
          break;
        case "search":
          //搜索工具
          vm = new Vue({
            // 为什么不使用 template 要使用render 因为现在是webpack里面没有编译器 只能使用render
            render: (h) => h(searchPop, { props: { map: this.view } } as any) // render 生成虚拟dom  {props: props}
          }).$mount(); // $mount 生成真实dom, 挂载dom 挂载在哪里, 不传参的时候只生成不挂载，需要手动挂载
          toolDiv = vm.$el as HTMLElement;
          toolDiv.id = "search";
          break;
          break;
        case "coordinate":
          //坐标工具
          break;
      }
      if (widget.config && widget.config.position) {
        if (typeof widget.config.position == "string") {
          position = widget.config.position;
        } else {
          relativePos = widget.config.position;
        }
      }
      if (toolDiv) {
        if (!defaultVisible) {
          toolDiv.style.display = "none";
        }
        this.view.getContainer().appendChild(toolDiv);
        if (relativePos) {
          toolDiv.style.left = relativePos.left || "";
          toolDiv.style.right = relativePos.right || "";
          toolDiv.style.top = relativePos.top || "";
          toolDiv.style.bottom = relativePos.bottom || "";
        }
      }
    }, this);
  }
  public async toggleWidget(widgetNames: string[] | string) {
    let widgets: string[] =
      typeof widgetNames === "string" ? [widgetNames] : widgetNames;
    widgets.forEach((widgetName) => {
      let widget: any = document.getElementById(widgetName);
      if (widget) {
        let el: any = widget.container || widget;
        if (el.style.display == "none") {
          el.style.display = "block";
        } else {
          el.style.display = "none";
        }
      }
    });
  }
}
